import type SimulationOptionsDto from '@/models/dto/credito/SimulationOptionsDto';
import type { SimulationTermOptionDto } from '@/models/dto/credito/SimulationOptionsDto';

export class SimulationTermOptionResource {
  termMonths: number;
  minimumAmount: number;
  maximumAmount: number;
  /**
   * O catálogo da UY3 não é simétrico: o produto sem seguro cobre uma faixa larga de prazos e os com
   * seguro são de prazo fixo, então existe prazo que só tem uma das pontas. Sem estas duas flags a
   * tela ofereceria um prazo em que a escolha padrão sempre seria recusada.
   */
  withInsuranceAvailable: boolean;
  withoutInsuranceAvailable: boolean;

  constructor(dto: SimulationTermOptionDto) {
    this.termMonths = dto.termMonths;
    this.minimumAmount = dto.minimumAmount;
    this.maximumAmount = dto.maximumAmount;
    this.withInsuranceAvailable = dto.withInsuranceAvailable;
    this.withoutInsuranceAvailable = dto.withoutInsuranceAvailable;
  }

  insuranceAvailableFor(preferComInsurance: boolean): boolean {
    return preferComInsurance ? this.withInsuranceAvailable : this.withoutInsuranceAvailable;
  }
}

export default class SimulationOptionsResource {
  recommendedTermMonths: number;
  terms: SimulationTermOptionResource[];

  constructor(dto: SimulationOptionsDto) {
    this.recommendedTermMonths = dto.recommendedTermMonths;
    this.terms = dto.terms.map(term => new SimulationTermOptionResource(term));
  }
}
